import PropertyGallery from './PropertyGallery';

function PropertyHeroSection({ property }) {
  const facilities = Array.isArray(property.facilities) ? property.facilities : [];
  const statusLabel = property.availability === 'opptatt' ? 'Opptatt' : 'Ledig';
  const images = Array.isArray(property.images) && property.images.length > 0
    ? property.images
    : property.imageUrl
      ? [property.imageUrl]
      : [];

  return (
    <section className="grid gap-6 lg:grid-cols-[minmax(0,1.2fr)_minmax(320px,0.8fr)]">
      <div className="overflow-hidden rounded-[32px] border border-[#1832281a] bg-[rgba(249,245,238,0.88)] shadow-[0_22px_60px_rgba(24,50,40,0.08)]">
        <PropertyGallery images={images} name={property.name} status={statusLabel} />
        <div className="px-6 py-8 md:px-8">
          <p className="mb-3 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">Detaljside</p>
          <h1 className="font-serif text-[clamp(2.4rem,4.6vw,4rem)] font-semibold leading-[1.04] text-[#163127]">
            {property.name}
          </h1>
          <p className="mt-3 text-lg text-[#7c6b52]">{property.address}</p>
          <p className="mt-6 max-w-[62ch] text-[1.05rem] leading-[1.8] text-[#355046]">
            {property.summary}
          </p>
          {facilities.length > 0 ? (
            <div className="mt-6">
              <p className="mb-3 text-xs uppercase tracking-[0.14em] text-[#7c6b52]">Fasiliteter</p>
              <ul className="flex flex-wrap gap-2">
                {facilities.map((facility) => (
                  <li
                    className="rounded-full border border-[#18322814] bg-[rgba(255,255,255,0.7)] px-4 py-2 text-sm font-semibold text-[#355046]"
                    key={facility}
                  >
                    {facility}
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
        </div>
      </div>

      <aside className="rounded-[32px] border border-[#1832281a] bg-[rgba(249,245,238,0.88)] p-6 shadow-[0_22px_60px_rgba(24,50,40,0.08)] md:p-8">
        <p className="mb-3 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">Nokkelinformasjon</p>
        <h2 className="font-serif text-[1.8rem] font-semibold leading-[1.2] text-[#163127]">Dette bor du vite med en gang</h2>
        <p className="mt-2 text-[1rem] leading-[1.7] text-[#355046]">
          Se status, pris og storrelse raskt for a vurdere om boligen passer for deg.
        </p>
        <dl className="grid gap-4">
          <div className="rounded-[20px] bg-[rgba(255,255,255,0.7)] p-4">
            <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Type</dt>
            <dd className="m-0 font-semibold text-[#163127]">{property.type}</dd>
          </div>
          <div className="rounded-[20px] bg-[rgba(255,255,255,0.7)] p-4">
            <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Storrelse</dt>
            <dd className="m-0 font-semibold text-[#163127]">{property.size}</dd>
          </div>
          {property.rooms ? (
            <div className="rounded-[20px] bg-[rgba(255,255,255,0.7)] p-4">
              <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Soverom</dt>
              <dd className="m-0 font-semibold text-[#163127]">{property.rooms}</dd>
            </div>
          ) : null}
          {property.bathrooms ? (
            <div className="rounded-[20px] bg-[rgba(255,255,255,0.7)] p-4">
              <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Bad</dt>
              <dd className="m-0 font-semibold text-[#163127]">{property.bathrooms}</dd>
            </div>
          ) : null}
          {property.availableFrom ? (
            <div className="rounded-[20px] bg-[rgba(255,255,255,0.7)] p-4">
              <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Tilgjengelighet</dt>
              <dd className="m-0 font-semibold text-[#163127]">{property.availableFrom}</dd>
            </div>
          ) : null}
          <div className="rounded-[20px] bg-[rgba(255,255,255,0.7)] p-4">
            <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Status</dt>
            <dd className="m-0 font-semibold text-[#163127]">{statusLabel}</dd>
          </div>
        </dl>
        <div className="mt-6 rounded-[24px] border border-[#18322812] bg-[rgba(255,255,255,0.52)] p-5">
          <p className="mb-2 text-xs uppercase tracking-[0.14em] text-[#7c6b52]">Beliggenhet</p>
          <p className="m-0 text-[1.05rem] leading-[1.7] text-[#355046]">
            Adressen er koblet til kartvisningen under, slik at besokende kan se hvor eiendommen ligger og aapne den direkte i Google Maps.
          </p>
        </div>
        <div className="mt-6 flex flex-wrap gap-3">
          <a
            className="focus-ring inline-flex min-h-12 items-center justify-center rounded-full bg-[#1d4c3b] px-[22px] font-semibold text-[#f9f5ee] no-underline"
            href="#meld-interesse"
          >
            Meld interesse
          </a>
          <a
            className="focus-ring inline-flex min-h-12 items-center justify-center rounded-full border border-[rgba(29,76,59,0.2)] bg-[rgba(255,255,255,0.72)] px-[22px] font-semibold text-[#1d4c3b] no-underline"
            href="#kart"
          >
            Se kart
          </a>
        </div>
      </aside>
    </section>
  );
}

export default PropertyHeroSection;